export default new Set([
  'Audi',
  'Acura',
  'Buick',
  'Chevrolet',
  'Chrysler',
  'Dodge',
  'Fiat',
  'Ford',
  'GMC',
  'Honda',
  'Hyundai',
  'Jeep',
  'Kia',
  'Lexus',
  'Lincoln',
  'Mazda',
  'Mitsubishi',
  'Ram',
  'Subaru',
  'Toyota',
  'Volkswagen',
  'Volvo',
]);



// WEBPACK FOOTER //
// ./src/main/data/whitelisted-oems.js